// extracted by mini-css-extract-plugin
export var addButton = "_5h-d";
export var bullets = "_5h-e";
export var compact = "_5h-2";
export var container = "_5h-j";
export var extendedWarrantyModal = "_5h-f";
export var learn = "_5h-l";
export var learnMore = "_5h-g";
export var offeringOption = "_5h-3";
export var offeringPrice = "_5h-8";
export var offeringSubtitle = "_5h-7";
export var offeringTitle = "_5h-6";
export var offeringsContainer = "_5h-0";
export var pdpTilesBackground = "_5h-n";
export var plan = "_5h-m";
export var regular = "_5h-1";
export var remove = "_5h-k";
export var seeDetailsIcon = "_5h-i";
export var seeDetailsLink = "_5h-h";
export var selectedOption = "_5h-4";
export var shieldIcon = "_5h-b";
export var shieldIconCompact = "_5h-c";
export var subtitle = "_5h-a";
export var title = "_5h-9";
export var unselectedOption = "_5h-5";